import { get } from 'lodash';
import FormInputTypes from '../../components/atoms/formEnums/formInputTypes';
export default {
  title: 'Live Logs',
  attributeName: 'liveLogs',    
  getURL: 'live/logs',
  sessionParams: [],
  idAttribute: 'id',
  
  
  fields: [
    {
      attributeName: 'log',
      type: FormInputTypes.LOG,
      hasRealTime:true,
      label: 'Logs',
      logData:{
        logDataValues:"logData",
        channel:"liveLogs-Logs-",
        getUrl:"liveLogsGeneralPaginated/",
        hasRealTime:true,
      },
      textNoResults:'(No logs found)',
      clearVisible:true,
      clearUrl:'live/logsclear',
      hasCounters:'counters',
      downloadLogs:true,
      downloadUrl:'live/logdownload',
      generateLogUrl:'live/loggenerate',
      filters:[
        {type:"action",text:"Actions"},
        {type:"error",text:"Errors"},
        {type:"WARN",text:"Warnings"},
        {type:"INFO",text:"Info"},
      ],
      legend:[
        {
          letter:"A",
          text:"Action LiveBackendApi",
          color:'bg-warning'
        },
        {
          letter:"E",
          text:"Error",
          color:'bg-danger'
        },
        {
          letter:"I",
          text:"Info Log",
          color:'bg-info'
        },
        {
          letter:"W",
          text:"Warning Log",
          color:'bg-warning'
        },
      ]

      
    },
  ],
};
